import api from "./axios";

export async function getSales({
  page = 1,
  pageSize = 25,
  query,
  source,
  status,
  paymentStatus,
  startDate,
  endDate,
} = {}) {
  const response = await api.get("/sales", {
    params: {
      page,
      page_size: pageSize,
      query: query || undefined,
      source: source || undefined,
      status: status || undefined,
      payment_status: paymentStatus || undefined,
      start_date: startDate || undefined,
      end_date: endDate || undefined,
    },
  });
  return response.data;
}

export async function getSale(publicId) {
  const response = await api.get(`/sales/${encodeURIComponent(publicId)}`);
  return response.data;
}
